import { render } from "./Snapchat.vue?vue&type=template&id=3d2ea6cc"
const script = {}
script.render = render

export default script